import React from "react";
import PropTypes from "prop-types";
import Menu from "@mui/material/Menu";

MenuModal.propTypes = {
  anchorEl: PropTypes.oneOfType([
    PropTypes.instanceOf(Element),
    PropTypes.instanceOf(HTMLElement),
  ]),
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
  paperSx: PropTypes.object,
  listSx: PropTypes.object,
  menuProps: PropTypes.object,
};

function flattenChildren(children) {
  const arr = React.Children.toArray(children);

  return arr.flatMap((child) => {
    // Fragmentだったら中身を取り出して展開
    if (React.isValidElement(child) && child.type === React.Fragment) {
      return flattenChildren(child.props.children);
    }
    return [child];
  });
}

export default function MenuModal({
  anchorEl,
  open,
  onClose,
  children,
  paperSx = {},
  listSx = {},
  menuProps = {},
}) {
  const content =
    typeof children === "function"
      ? children()
      : children;

  // Fragmentを展開して、Menu直下がFragmentにならないようにする
  const flat = flattenChildren(content);

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      slotProps={{
        list: {
          sx: { p: 0, ...listSx },
        },
        paper: {
          sx: {
            width: 260,
            borderRadius: 2,
            mt: 1,
            ...paperSx,
          },
        },
      }}
      {...menuProps}
    >
      {flat}
    </Menu>
  );
}